<template>
    <modal id="course-checkout-modal" @trigger="createAutocompleteAddress">
        <template slot="title">
            Registration
        </template>
        <template slot="body">

            <div class="mb-4" v-if="options.hasOwnProperty('schedules')">
                <h6 v-text="__('Pick a Date')"></h6>
                <ul class="list-group">
                    <li v-for="schedule in options.schedules" :key="schedule.id" class="list-group-item">
                        <label :for="schedule.id" class="d-flex align-items-center mb-0">
                            <input class="mr-2" type="radio" :id="schedule.id" v-model="form.schedule_id" :value="schedule.id">
                            <div class="d-flex flex-column ml-2">
                                {{ descriptiveDate(schedule.date) }}
                                <div class="text-sm text-info" v-if="course.provider == 'schedule'">
                                    <div v-text="`${schedule.address} ${schedule.city} ${schedule.state}, ${schedule.zip}`"></div>
                                </div>
                            </div>
                        </label>
                    </li>
                </ul>
            </div>

            <div class="mb-4" v-if="options.payload.hasOwnProperty('address')">
                <field-input v-model="form.address" label="Address" id="autocomplete-address"></field-input>
                <field-input v-model="form.city" label="City"></field-input>
                <field-input v-model="form.state" label="State"></field-input>
                <field-input v-model="form.zip" label="Zip"></field-input>
            </div>

            <div class="mb-4" v-else>
                Complete the registration.
            </div>

            <payment-form v-if="form.with_payment" v-model="form.stripe_token"></payment-form>

        </template>
        <template slot="footer">
            <button class="btn-app-green" :disabled="isDisabled" @click="checkout">
                <span v-if="form.isSubmitted">
                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Processing...
                </span>
                <span v-else>
                    Checkout
                </span>
            </button>
        </template>
    </modal>
</template>
<script>

    import Input from "../Fields/Input";
    let AutoCompleteAddress = require('@/mixins/AutoCompleteAddress');

    export default {

        components: {
            Input
        },

        mixins: [AutoCompleteAddress],

        props: {
            course: {
                type: Object,
            },
            url: {
                type: String,
                required: true,
            },
            options: {
                type: Object,
                required: false,
                default: () => {
                    return {}
                }
            },
            redirectUrl: {
                type: String,
                required: false,
                default: `/admin/users/${config.userId}/#courses`,
            },
            withPayment: {
                type: Boolean,
                required: false,
                default: true,
            },
            signInMethod: {
                type: String,
                required: false,
                default: 'course',
            }
        },

        data() {
            return {
                form: null,
            }
        },

        created() {
            this.buildFormRequest()
        },

        methods: {
            checkout() {
                App.bus.$emit('checkout');
                this.form.post(this.url).then(response => {
                    this.closeModal('course-checkout-modal');
                    Alert.timer(`Thank you for signing up. <br>More information will be sent by email.`).then(response => {
                        this.redirectTo(this.redirectUrl);
                    })
                }).catch(errors => {
                    App.bus.$emit('checkout-error');
                    Alert.error(errors.first())
                })
            },

            buildFormRequest() {

                var data = {
                    sign_in_method : this.signInMethod,
                    with_payment: this.withPayment,
                    stripe_token: null,
                    ...this.options.payload
                }

                if (this.options.hasOwnProperty('schedules')) {
                    const urlParams = new URLSearchParams(window.location.search);
                    data['schedule_id'] = (urlParams.has('schedule') && urlParams.get('schedule') != '') ? urlParams.get('schedule') : null;
                }

                this.form = new Form(data).dontClear()
            },
        },

        computed: {

            isDisabled() {

                if (this.options.hasOwnProperty('schedules') && this.form.schedule_id == null) {
                    return true;
                }

                return (this.withPayment && !this.form.stripe_token) || this.form.isSubmitted;
            }
        }
    }
</script>
